/**
* 馨康宝
*
* @author 张毅
*
*/

<template>
	<div id="app" v-if="draw">
		<div class="main">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {
				license: undefined,
				logonUser: undefined,
				isLogon: false,
				isRoot: false,
				isAdmin: false,
				isUser: false,
				draw: false
			}
		},
		methods: {
			checkLicense: async function() {
				var entity = await this.$axios.get('/api/signin/licence');
				this.license = entity.data;
			},
			checkLogonUser: async function() {
				var regex = new RegExp('^zhangy:');
				this.isLogon = sessionStorage.getItem('Authorization-Token') !== null && regex.test(sessionStorage
					.getItem('Authorization-Token'));
				if (this.isLogon) {
					var entity = await this.$axios.get('/api/logon/user');
					this.logonUser = entity.data;
					this.isRoot = this.logonUser.id === '1000000000000000000';
					this.isAdmin = this.logonUser.role === 'admin';
					this.isUser = this.logonUser.role === 'user' || this.logonUser.role === 'vip';
				} else {
					this.isRoot = false;
					this.isAdmin = false;
					this.isUser = false;
				}
			},
			switchToStarter: function() {
				this.$router.push('/area');
			}
		},
		mounted: async function() {
			await this.checkLicense();
			await this.checkLogonUser();
			this.draw = true;
		}
	}
</script>



// WEBPACK FOOTER //
// src/App.vue